import { render, staticRenderFns } from "./FormSetupStreamax.vue?vue&type=template&id=6099236e&scoped=true&"
import script from "./FormSetupStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormSetupStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormSetupStreamax.vue?vue&type=style&index=0&id=6099236e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6099236e",
  null
  
)

export default component.exports